export default __webpack_public_path__ + "static/media/Icon_Poll_Blue.96a900ed.png";